<template>
  <div class="tag-item">
    <div class="text">{{ text }}</div>
    <CloseCircleIcon v-if="!readonly" class="icon" fillColor="#F3F3F2" @click="onClickDelete" />
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from "vue";
import CloseCircleIcon from "icons/CloseCircle.vue";

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    CloseCircleIcon,
  },
  props: {
    text: String as PropType<string>,
    readonly: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  methods: {
    async onClickDelete() {
      this.$emit("delete");
    },
  },
});

interface Props {
  text: string;
  readonly: boolean;
}

interface Data {}

interface Computed {}

interface Methods {
  onClickDelete(): void;
}
</script>

<style lang="scss" scoped>
.tag-item {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 4px 8px;
  border-radius: var(--radius-lg);
  background-color: var(--color-inactive);

  [data-app-theme="dark"] & {
    background-color: #6e6e6e;
  }

  .text {
    color: var(--color-text-on-fixed-bg);
    font-weight: var(--font-weight-bold);
  }

  .icon {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 4px;
    cursor: pointer;
  }
}
</style>
